/* eslint-disable no-shadow,consistent-return,no-param-reassign */
import jApiThirdParty from '@/services/jApiThirdParty';

const state = {
  list_plugin: [],
  list_connection: [],
};

const getters = {
};

const mutations = {
  setPlugin(state, data) {
    state.list_plugin = data.data;
  },
  setConnection(state, data) {
    state.list_connection = data.data.data;
  },
};

const actions = {
  async detailThirdPartyConnection({ dispatch }, req, useLoading) {
    if (useLoading) dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const res = await jApiThirdParty.detailThirdPartyConnection(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response;
    }
  },
  async createThirdPartyConnection({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const res = await jApiThirdParty.createThirdPartyConnection(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      return res.data;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },
  async updateThirdPartyConnection({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const res = await jApiThirdParty.updateThirdPartyConnection(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      return res.data;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },
  async deleteThirdPartyConnection({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const res = await jApiThirdParty.deleteThirdPartyConnection(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      return res.data;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },
  async getThirdPartyPlugin({ commit, dispatch }) {
    try {
      const res = await jApiThirdParty.getThirdPartyPlugin();
      commit('setPlugin', res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },
  async getListThirdPartyConnection({ commit, dispatch }, data) {
    try {
      const res = await jApiThirdParty.getListThirdPartyConnection(data);
      commit('setConnection', res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },
  async getAsyncListThirdPartyConnection({ dispatch }, { reqData, callback }) {
    try {
      const resData = await jApiThirdParty.getListThirdPartyConnection(reqData);
      const res = resData.data.data ? resData.data.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.connection_name;
        res[index].text = lab.connection_name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreThirdParty.js